import React from 'react';
import { useTranslation } from 'react-i18next';
import { PageHeader } from '../components/page-header';
import { usePerformanceReviewAccess } from '../hooks';

/**
 * Reviews list. Placeholder shell wired to the route in this story; the table,
 * filters, and actions land with the manager list story.
 */
const PerformanceReviews: React.FC = () => {
  const { t } = useTranslation('performanceReview');
  const canView = usePerformanceReviewAccess();

  if (!canView) {
    return null;
  }

  return (
    <div>
      <PageHeader title={t('title')} description={t('description')} testId="performance-reviews" />
    </div>
  );
};

export default PerformanceReviews;
